import classNames from 'classnames';
import React from 'react';

import Heading from '@jpp/atoms/Heading';
import Button from '@jpp/molecules/Button';
import CartPromoCode from '@jpp/molecules/Cart/CartPromoCode';
import Container from '@jpp/shared/Grid/Container';
import Flex from '@jpp/shared/Grid/Flex';
import Row from '@jpp/shared/Grid/Row';
import Section from '@jpp/shared/Grid/Section';
import { ECtaTheme, EPageType, ETheme } from 'common/typings/enums';

import './EmptyCart.scss';

interface IEmptyCartProps {
  className?: string;
}

const ROOT_CLASSNAME = 'EmptyCart';

const EmptyCart: React.FunctionComponent<IEmptyCartProps> = ({ className }) => {
  return (
    <Section
      className={classNames(ROOT_CLASSNAME, className)}
      theme={ETheme.TintAlpha}
    >
      <Container>
        <Row>
          <Flex className="text-center">
            <Heading
              className={`${ROOT_CLASSNAME}__heading`}
              priority={1}
              isBold={true}
              children="Your cart is empty"
            />

            <CartPromoCode className={`${ROOT_CLASSNAME}__promo-code`} />

            <Button
              behaviour="router"
              link={`/${EPageType.Shop}`}
              className={`${ROOT_CLASSNAME}__button`}
              theme={ECtaTheme.BrandOutline}
            >
              Return to shop
            </Button>
          </Flex>
        </Row>
      </Container>
    </Section>
  );
};

export default EmptyCart;
